import Vue from 'vue';
import purchaseTransformer from './../../transformers/purchase';
import store from '../../store';

const success = ({ data }, resolve) => {
  const purchase = purchaseTransformer.fetch(data);
  store.dispatch('RefreshStockProductsCustom');
  store.dispatch('fetchCurrentPurchase', purchase);
  store.dispatch('allCurrentStockProductsCustom', purchase.products);
  resolve(purchase);
};

const failed = () => {};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/purchases/unfinished/purchase/products')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/showUnfinished.js